export default __webpack_public_path__ + "files/87275e3c54a7ae07022abd6a0ddb9283.mp3";